import PropTypes from 'prop-types'

import ButtonLink from './ButtonLink'

export default function LinkButton({ to, text = undefined, icon = undefined }) {
  return (
    <ButtonLink to={to} icon={icon} size="large" type="link">
      {text}
    </ButtonLink>
  )
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.node,
}
